"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[VideoPriorityBasedPolicyConfig]] contains the network issue response delay and network issue recovery delay.
 */

var VideoPriorityBasedPolicyConfig = /*#__PURE__*/_createClass(
/** Initializes a [[VideoPriorityBasedPolicyConfig]] with the network event delays.
 *
 * @param networkIssueResponseDelayFactor Delays before reducing subscribed video bitrate. Input should be a value between 0 and 1.
 * @param networkIssueRecoveryDelayFactor Delays before starting to increase bitrates after a network event and
 * delays between increasing video bitrates on each individual stream. Input should be a value between 0 and 1.
 */
function VideoPriorityBasedPolicyConfig() {
  var networkIssueResponseDelayFactor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var networkIssueRecoveryDelayFactor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  _classCallCheck(this, VideoPriorityBasedPolicyConfig);

  this.networkIssueResponseDelayFactor = networkIssueResponseDelayFactor;
  this.networkIssueRecoveryDelayFactor = networkIssueRecoveryDelayFactor;

  if (networkIssueResponseDelayFactor < 0) {
    networkIssueResponseDelayFactor = 0;
  } else if (networkIssueResponseDelayFactor > 1) {
    networkIssueResponseDelayFactor = 1;
  }

  this.networkIssueResponseDelayFactor = networkIssueResponseDelayFactor;

  if (networkIssueRecoveryDelayFactor < 0) {
    networkIssueRecoveryDelayFactor = 0;
  } else if (networkIssueRecoveryDelayFactor > 1) {
    networkIssueRecoveryDelayFactor = 1;
  }

  this.networkIssueRecoveryDelayFactor = networkIssueRecoveryDelayFactor;
});

exports.default = VideoPriorityBasedPolicyConfig; // presets

VideoPriorityBasedPolicyConfig.Default = new VideoPriorityBasedPolicyConfig(0, 0);
VideoPriorityBasedPolicyConfig.UnstableNetworkPreset = new VideoPriorityBasedPolicyConfig(0, 1);
VideoPriorityBasedPolicyConfig.StableNetworkPreset = new VideoPriorityBasedPolicyConfig(1, 0);